import React from "react";
import "./HeroSection.css";

const images = [
  "/crousel.jpg",
  "/11.png",
  "/3dbuilding.png",
  "/3dmodelingcivil.png",
  "/3dmodelingwhite.png",
  "3d/piping/Roaster 4.png",
   "3d/piping/Roaster 3.png",
  "3d/pf/PF1.jpg",
  "3d/plantdesign/B1.jpg",
  "3d/plantdesign/B2.jpg",
  "3d/plantdesign/RD/R3.jpg",

];

const HeroSection = () => {
  // Duplicate images for seamless looping
  const duplicatedImages = [...images, ...images];
  
  return (
    <div className="hero-cards-wrapper">
      <div className="hero-cards-container">
        {duplicatedImages.map((src, index) => (
          <div key={index} className="hero-card">
            <img
              src={src}
              alt={`Card ${index}`}
              className="hero-card-img"
              loading="lazy"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default HeroSection;